exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1UzSPfVlxCqibAtmB6hzTs{list-style-type:none}html[dir] ._1UzSPfVlxCqibAtmB6hzTs{padding:0}._3mV-juFNOApMVQ3JThmJHH{font-weight:400;color:\"[theme:themePrimary, default:#0078D7]\";font-size:13px;cursor:pointer}html[dir] ._3mV-juFNOApMVQ3JThmJHH{padding-top:15px}._1hPfaG5GLSAvVdUPSW91pN{top:0;height:700px}html[dir=ltr] ._1hPfaG5GLSAvVdUPSW91pN{left:0}html[dir=rtl] ._1hPfaG5GLSAvVdUPSW91pN{right:0}._3jvoKvvl6LABckgv3DriWO{position:absolute}html[dir] .GXL2OGSGcTe3QTUCbWwyK{padding-top:200px}", ""]);

// exports
exports.locals = {
	"actions": "_1UzSPfVlxCqibAtmB6hzTs",
	"action": "_3mV-juFNOApMVQ3JThmJHH",
	"miniMavenWidget": "_1hPfaG5GLSAvVdUPSW91pN",
	"actionsDiv": "_3jvoKvvl6LABckgv3DriWO",
	"miniMavenWidgetLoading": "GXL2OGSGcTe3QTUCbWwyK"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":{"orderedValues":false}}!./node_modules/postcss-loader/lib?{"plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./obj/controls/header/owa-header-pane/lib/components/HeaderPane.scss
// module id = 6209
// module chunks = 38